import { useCallback, useEffect, useState } from 'react';

export default function useInboxScreenMobileUI({
  selectedConversationId,
  clearSelectedConversation
}) {
  const [showMobileRightSidebar, setShowMobileRightSidebar] = useState(false);
  const [isDesktopLayout, setIsDesktopLayout] = useState(false);

  const handleToggleMobileRightSidebar = useCallback(() => {
    setShowMobileRightSidebar((prevState) => !prevState);
  }, []);

  const handleCloseMobileRightSidebar = useCallback(() => {
    setShowMobileRightSidebar(false);
  }, []);

  const handleMobileCloseConversation = useCallback(() => {
    setShowMobileRightSidebar(false);
    clearSelectedConversation();
  }, [clearSelectedConversation]);

  useEffect(() => {
    if (!selectedConversationId) {
      setShowMobileRightSidebar(false);
    }
  }, [selectedConversationId]);

  useEffect(() => {
    const desktopQuery = window.matchMedia('(min-width: 768px)');
    const handleDesktopChange = (event) => {
      setIsDesktopLayout(event.matches);
    };

    setIsDesktopLayout(desktopQuery.matches);
    desktopQuery.addEventListener('change', handleDesktopChange);

    return () => {
      desktopQuery.removeEventListener('change', handleDesktopChange);
    };
  }, []);

  return {
    showMobileRightSidebar,
    isDesktopLayout,
    handleToggleMobileRightSidebar,
    handleCloseMobileRightSidebar,
    handleMobileCloseConversation
  };
}

